import { render, staticRenderFns } from "./RegistInformationComplete.vue?vue&type=template&id=76aa9f8a&scoped=true&lang=pug&"
import script from "./RegistInformationComplete.vue?vue&type=script&lang=ts&"
export * from "./RegistInformationComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aa9f8a",
  null
  
)

export default component.exports